<!-- header Start-->

<section class="yoga header" id="main">

  <owl-carousel-o [options]="homeCarouselOptions" class="yoga-content overflow-hidden yoga-slider">
    <ng-container *ngFor="let yoga of yogas">
      <ng-template carouselSlide class="item">
              <div class="yogas bg" style="background: url(assets/images/home-carousel-1.jpg) no-repeat 50% 50px fixed; background-size: cover !important;">
                  <div class="container">
                      <div class="row">
                          <div class="col-md-12">
                              <div class="center-text">
                                  <div class="bottom-0 set-abs girl center-content">
                                        <div class="row middle-box " style="background-color: rgb(0 0 0 / 40%);border-radius: 30px;">
                                          <div class="col-lg-2 col-md-0 logo-img-col">
                                            <img _ngcontent-serverapp-c18="" alt="logo" src="assets/images/logo/logo-1.png" class="logo-abs h-auto">
                                          </div>
                                            <div class="col-lg-10 col-md-12" >
                                                <div class="right-way">
                                                    <div class="header-text"><h1>Petro Vorster & Partners </h1></div>
                                                    <div class="header-sub-text">
                                                        <h2><span class="bold-text">Registered Physiotherapists</span></h2>
                                                    </div>
                                                    <div class="col-lg-10 col-md-12 text-center">
                                                      <a class="btn btn-default back-white border-not" (click)="readMore()">read more</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                  </div>

                              </div>
                          </div>
                          <div class="animation-circle-inverse">
                              <i></i>
                              <i></i>
                              <i></i>
                          </div>
                      </div>
                  </div>
              </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
 </section>
<!-- header end-->
